// Keep CMS text inside the JSON-LD script, including literal </script> in content.
export function serializeJsonLd(value) {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

export function buildFaqSchema(items = []) {
  const questions = items.filter(
    (item) => typeof item?.question === "string" && typeof item?.answer === "string"
      && item.question.trim() && item.answer.trim()
  );
  if (!questions.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: { "@type": "Answer", text: answer },
    })),
  };
}

// Connect each page to the existing site/product entities without duplicating them.
// FAQ text comes from the same data rendered on the page.
export function buildPageSchemas({ url, locale, title, description, faqs = [] }) {
  const faq = buildFaqSchema(faqs);
  const pageId = `${url}#webpage`;
  const faqId = `${url}#faq`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": pageId,
        url,
        name: title,
        description,
        inLanguage: locale === "tr" ? "tr-TR" : "en-US",
        isPartOf: { "@id": "https://palmate.ai#website" },
        about: { "@id": "https://palmate.ai#software" },
        publisher: { "@id": "https://palmate.ai#organization" },
        ...(faq ? { hasPart: { "@id": faqId } } : {}),
      },
      ...(faq ? [{
        ...faq,
        "@id": faqId,
        isPartOf: { "@id": pageId },
        inLanguage: locale === "tr" ? "tr-TR" : "en-US",
      }] : []),
    ],
  };
}
